import draytonPic from "@/public/images/artists/drayton.png";
import { Artist } from "@/types/types";

export const drayton = {
  id: "239",
  name: "Drayton",
  image: draytonPic,
  description: `Drayton has a low, measured tone. His words land slow and sure, carrying a laid-back confidence.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdrayton-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Spoken Word"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Low",
      },
      specific: {
        low: 40,
        high: 59,
      },
      sweetSpot: 47,
    },
  },
} as const satisfies Artist;
